import { LessonType } from 'types';
import { LessonForLmsQuery } from 'core';
import { formatLessonRange, isLessonOver } from 'services/LessonTimeService';
import { LessonTypes } from 'components/types/common';

export const transformLesson = (data: LessonForLmsQuery | undefined): LessonType => {
  if (data?.lessonForLms) {
    const lessonType = data.lessonForLms.__typename;

    const { date, startsAt, endsAt } = data.lessonForLms;
    // ТЗ 0100: время — из моментов, в поясе браузера; «прошло» — по концу.
    const time = formatLessonRange(startsAt, endsAt, undefined, date);
    const isEnded = isLessonOver({ startsAt, endsAt, date });

    return {
      id: data.lessonForLms.id,
      name: data.lessonForLms.name,
      index: data.lessonForLms.index || 0,
      isEnded,
      isActive: !isEnded,
      needToFinish:
        lessonType === LessonTypes.GroupLessonForLMSType ? data.lessonForLms?.needToFinish : null,
      time,
      startsAt: startsAt ?? null,
      endsAt: endsAt ?? null,
      date: data.lessonForLms.date,
      finished: data.lessonForLms.finished,
      lmsDescription: data.lessonForLms.lmsDescription || '',
      comment: data.lessonForLms.comment || '',
      video: data.lessonForLms.video,
      taskTypes:
        lessonType === LessonTypes.GroupLessonForLMSType ? data.lessonForLms.taskTypes : [],
      hasStudentMarks:
        lessonType === LessonTypes.StudentLessonType ? data.lessonForLms.hasStudentMarks : null,
      hasTeacherAttachment:
        lessonType === LessonTypes.GroupLessonForLMSType ||
        lessonType === LessonTypes.MethodistLessonType
          ? data.lessonForLms.hasTeacherAttachment
          : false,
      hasStudentAttachment:
        lessonType === LessonTypes.StudentLessonType ||
        lessonType === LessonTypes.MethodistLessonType
          ? data.lessonForLms.hasStudentAttachment
          : false,
      whiteboardId: data.lessonForLms.whiteboardId ?? null,
      homeworkAssignmentId: data.lessonForLms.homeworkAssignmentId ?? null,
      homeworkAvailable: data.lessonForLms.homeworkAvailable ?? null,
      hasJoinLink: data.lessonForLms.hasJoinLink ?? null,
      linkOverrideActive: data.lessonForLms.linkOverrideActive ?? null,
    };
  }

  return {
    id: '',
    name: '',
    index: 0,
    isEnded: false,
    time: '',
    date: '',
    finished: false,
    lmsDescription: '',
    comment: '',
    taskTypes: [],
  };
};
